import {Route, Switch, useRouteMatch} from "react-router-dom";
import AboutUs from "../../pages/morePages/aboutUs/AboutUs";
import Complaint from "../../pages/morePages/complaint/Complaint";
import ContentUs from "../../pages/morePages/contactUs/ContactUs";
import Rules from "../../pages/morePages/rules/Rules";
import React from "react";
import {Container} from "react-bootstrap";

const MorePages = () => {
    const match = useRouteMatch();
    return (
        <Container fluid={true}>
            <Switch>
                <Route path={`${match.path}/about-us`}><AboutUs/></Route>
                <Route path={`${match.path}/complaint`}><Complaint/></Route>
                <Route path={`${match.path}/contact-us`}><ContentUs/></Route>
                <Route path={`${match.path}/rules`}><Rules/></Route>
            </Switch>
        </Container>
    )
}

export default MorePages;
